"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiDialog = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../hooks");
const rootElement = document.getElementById('root');
function UiDialog({ toggle, children, isOpen, setIsOpen, fullScreen, onClose, maxWidth, className, }) {
    hooks_1.useKeyboardListener(onClose);
    const [element, setElement] = react_1.useState();
    react_1.useEffect(() => {
        const element = document.createElement('div');
        setElement(element);
        rootElement === null || rootElement === void 0 ? void 0 : rootElement.appendChild(element);
        return () => {
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.removeChild(element);
        };
    }, []);
    react_1.useEffect(() => {
        if (isOpen) {
            document.documentElement.classList.add('hide-overflow');
            return () => {
                document.documentElement.classList.remove('hide-overflow');
            };
        }
    }, [isOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        toggle && react_1.default.cloneElement(toggle, { onClick: () => setIsOpen(true) }),
        isOpen &&
            element &&
            react_dom_1.default.createPortal(react_1.default.createElement("div", { className: clsx_1.default(className, 'UiDialog', { fullScreen }) },
                react_1.default.createElement("div", { className: "UiDialog-overlay", onClick: onClose }),
                react_1.default.createElement("div", { className: clsx_1.default('UiDialog-container', maxWidth && `maxWidth-${maxWidth}`) },
                    react_1.default.createElement("div", { className: "UiDialog-content" }, children))), element)));
}
exports.UiDialog = UiDialog;
